import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ProfileTypeService } from '../../../../../../core/services/contact/contact-type/contact-type.service'
import { NgxMaskDirective } from 'ngx-mask'
import {MatTimepicker, MatTimepickerInput, MatTimepickerToggle} from '@angular/material/timepicker';
import {NgForOf} from '@angular/common';
import {
  MedicalInsuranceService
} from '../../../../../../core/services/medical-insurance/municipality/medical-insurance.service';
@Component({
  selector: 'medical-insurance-patient-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    NgForOf,
  ],
  templateUrl: './medical-insurance-patient-edit-form.component.html',
  styleUrl: './medical-insurance-patient-edit-form.component.scss',
  providers: [MedicalInsuranceService],
  standalone: true,
})
export class MedicalInsurancePatientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private medicalInsuranceService: MedicalInsuranceService,
  ) {}
  diasSemanaList: any[] = []
  messagesList: any[] = []
  timeList: any[] = []
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  @Input() paciente_id: number = 0;
  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []

  ngOnInit(): void {
  //  this.getListType()
    this.createForm()
    this.getConvenios()
  }
  getConvenios(){
    this.medicalInsuranceService.listActiveMunicipality().subscribe({
      next: (response: ResponseRequestModel) => {
        console.log(response,'response')
        //@ts-ignore
        this.messagesList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
      console.log('editItem')
    }
  }
  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  // getListType() {
  //   this.contactTypeService.listContactType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //     },
  //     complete: () => {},
  //   })
  // }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.id) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  fillForm() {
    console.log(this.editItem)
    this.form.get('identif')?.setValue(this.editItem.num_identificacao)
    this.form.get('medInsurance')?.setValue(this.editItem.id_convenio)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      identif: ["", [Validators.required]],
      medInsurance: [null, [Validators.required]],
    })
  }


  createContact() {
    this.loading = true
    const model = this.createModel()
    this.medicalInsuranceService.createPatientMDINS(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)

        this.response.emit(true)
      },
      error: (err: any) => {
        this.snackbar.error("Ocorreu um erro, verifique com o suporte")

      },
      complete: () => {
        this.resetForm()
        this.loading = false
        this.editItem = {}
      },
    });
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.medicalInsuranceService.editPatientMDINS(model).subscribe({
      next: (response: any) => {
        this.response.emit(true)
        this.snackbar.success(response.message)
        this.resetForm();
        this.editItem = {}
      },
      error: (err: any) => {
        this.snackbar.error("Ocorreu um erro, verifique com o suporte")
      },
      complete: () => {
        this.resetForm()
        this.loading = false
        this.editItem = {}
      },
    })
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
    this.editItem = {}
  }
  formatHour(hora: string | number): string {
    if (!hora) return '';

    // transforma em string, caso seja number
    const strHora = hora.toString().padStart(4, '0'); // garante 4 caracteres
    return strHora.slice(0, 2) + ':' + strHora.slice(2, 4);
  }
  createModel(edit: boolean = false) {
    if (edit) {
      return {
        id: this.editItem.id,
        id_convenio: this.form.controls['medInsurance'].value,
        num_identificacao: this.form.controls['identif'].value,

      }
    } else {
      return {
        id_paciente: this.paciente_id,
        id_convenio: this.form.controls['medInsurance'].value,
        num_identificacao: this.form.controls['identif'].value,
      }
    }
  }
  }
